module.exports = __webpack_public_path__ + "img/modosWeb.24fd86f4.png";